import { createElement, memo, useEffect, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
import { getImageUrl } from '../../lib/utils/imageUtils';
const FlightRound = (props) => {
    const [tripType, setTripType] = useState(2);
    const [roundData, setRoundData] = useState([]);
    const [roundIndex, setRoundIndex] = useState(props.apiConfig.count);
    const [singleData, setSingleData] = useState([]);
    const [singleIndex, setSingleIndex] = useState(props.apiConfig.count);
    const [flightData, setFlightData] = useState([]);
    const [roundInfo, setRoundInfo] = useState([]);
    const [singleInfo, setSingleInfo] = useState([]);
    useEffect(() => {
        if (props.flightList && props.flightList.length > 0) {
            const newRoundData = props.flightList.map(item => ({
                departCityCode: item.forwardDirectFlight.departCityCode,
                departCityName: item.forwardDirectFlight.departCityName,
                arriveCityCode: item.forwardDirectFlight.arriveCityCode,
                arriveCityName: item.forwardDirectFlight.arriveCityName,
                date: item.forwardDirectFlight.flightDate,
                backDate: item.backwardDirectFlight.flightDate,
                price: item.totalPrice,
                imgUrl: item.forwardDirectFlight.cityPicture
            }));
            setRoundData(newRoundData && newRoundData.length ? newRoundData.slice(0, roundIndex) : []);
            if (tripType !== 1) {
                setFlightData(newRoundData && newRoundData.length ? newRoundData.slice(0, roundIndex) : []);
            }
        }
    }, [props.flightList]);
    useEffect(() => {
        if (props.singleList && props.singleList.length > 0) {
            const newSingleData = props.singleList.map(item => ({
                departCityCode: item.forwardDirectFlight.departCityCode,
                departCityName: item.forwardDirectFlight.departCityName,
                arriveCityCode: item.forwardDirectFlight.arriveCityCode,
                arriveCityName: item.forwardDirectFlight.arriveCityName,
                date: item.forwardDirectFlight.flightDate,
                price: item.forwardDirectFlight.price,
                imgUrl: item.forwardDirectFlight.cityPicture
            }));
            setSingleData(newSingleData && newSingleData.length ? newSingleData.slice(0, singleIndex) : []);
            if (tripType === 1) {
                setFlightData(newSingleData && newSingleData.length ? newSingleData.slice(0, singleIndex) : []);
            }
        }
    }, [props.singleList]);
    const jumpList = (item, index) => {
        const flight = Object.assign({}, item);
        props.jump(flight, index);
    };
    const change = () => {
        if (tripType === 1) {
            let newSingleInfo;
            if (singleIndex + props.apiConfig.count > (singleData === null || singleData === void 0 ? void 0 : singleData.length)) {
                let fill = props.apiConfig.count - ((singleData === null || singleData === void 0 ? void 0 : singleData.length) - singleIndex);
                newSingleInfo = singleData === null || singleData === void 0 ? void 0 : singleData.slice(singleIndex).concat(singleData === null || singleData === void 0 ? void 0 : singleData.slice(0, fill));
                setSingleIndex(fill);
            }
            else {
                let next = singleIndex + props.apiConfig.count;
                newSingleInfo = singleData === null || singleData === void 0 ? void 0 : singleData.slice(singleIndex, next);
                setSingleIndex(next);
            }
            setSingleInfo(newSingleInfo);
            setFlightData(newSingleInfo);
        }
        else {
            let newRoundInfo;
            if (roundIndex + props.apiConfig.count > (roundData === null || roundData === void 0 ? void 0 : roundData.length)) {
                let fill = props.apiConfig.count - ((roundData === null || roundData === void 0 ? void 0 : roundData.length) - roundIndex);
                newRoundInfo = roundData === null || roundData === void 0 ? void 0 : roundData.slice(roundIndex).concat(roundData === null || roundData === void 0 ? void 0 : roundData.slice(0, fill));
                setRoundIndex(fill);
            }
            else {
                let next = roundIndex + props.apiConfig.count;
                newRoundInfo = roundData === null || roundData === void 0 ? void 0 : roundData.slice(roundIndex, next);
                setRoundIndex(next);
            }
            setRoundInfo(newRoundInfo);
            setFlightData(newRoundInfo);
        }
    };
    useEffect(() => {
        console.log('flightData...', flightData);
        console.log('props.styles.ui', props.styles);
        console.log('props.singleList.length', props.singleList.length);
        console.log('props.apiConfig.count', props.apiConfig.count);
    }, [flightData]);
    return <View className='flight-special-ticket-container'>
      <View className='special' style={{
        background: props.styles.background
    }}>
        <View x-if={props.titleConfig.title} className='flex title'>
          <View className='title-after' style={{
        backgroundColor: props.titleConfig.titleLeft
    }}></View>
          <Text className='flex-item label' style={{
        color: props.titleConfig.titleColor
    }}>{props.titleConfig.title}</Text>
          <Text x-if={props.singleList.length > props.apiConfig.count} className='flex-item-switch' style={{
        color: props.titleConfig.switchBg
    }} onClick={change}>
            {props.titleConfig.switch}
          </Text>
        </View>
        <View className='airline'>
          
          <View x-if={props.styles.ui === '1'} className='wrapper'>
            {flightData.map((item, index) => {
        return <View className='list' key={index} onClick={() => jumpList(item, index)} style={{
            background: props.styles.listBackground
        }}>
                  <Image className='corner-img' source={{
            uri: getImageUrl(props.styles.cornerLabelImg, 63, 0)
        }}/>
                  <View x-if={props.styles.cornerLabelImg && props.styles.cornerLabel} className='corner-label' style={{
            backgroundColor: props.styles.cornerLabelBgColor,
            color: props.styles.cornerLabelColor
        }}>
                    {props.styles.cornerLabel}
                  </View>
                  <View className='info' x-class={{
            'move-down': props.styles.cornerLabel || props.styles.cornerLabelImg
        }}>
                    <View className='line'>
                      <View className='site'>
                        <Text className='site-item'>{item.departCityName}</Text>
                        <View className='arrow' x-class={{
            'oneway': tripType === 1,
            'twoway': !(tripType === 1)
        }}></View>
                        <Text className='site-item'>{item.arriveCityName}</Text>
                      </View>
                    </View>
                    <View className='date'>
                      <Text x-if={!(tripType === 1)} className='date-go'>去</Text>
                      <Text className='date-go'>{item.date}</Text>
                      <Text x-if={!(tripType === 1)} className='date-back'>返 {item.backDate}</Text>
                    </View>
                  </View>
                  <View x-class={['price', {
                'price-mini': String(item.price).length > 4,
                'move-down': props.styles.cornerLabel || props.styles.cornerLabelImg,
                'price-single': tripType === 1
            }]} style={{
            color: props.styles.priceColor
        }}>
                    <Text className='price-symbol'>￥</Text>
                    <Text className='price-large'>{item.price}</Text>
                    <Text x-if={!(tripType === 1)} className='price-symbol'>起</Text>
                  </View>
                  <View className='btn' x-class={{
            'move-down': props.styles.cornerLabel || props.styles.cornerLabelImg
        }}>
                    <Text className='btn-text' style={{
            background: props.styles.buttonBackground
        }}>预订</Text>
                  </View>
                </View>;
    })}
          </View>

          
          <View x-if={props.styles.ui === '2'} className='wrapper-ui-2 flex'>
            {flightData.map((item, index) => {
        return <View className='list' key={index} onClick={() => jumpList(item, index)}>
                  <Image className='corner-img' source={{
            uri: getImageUrl(props.styles.cornerLabelImg, 51, 0)
        }}/>
                  <View x-if={!props.styles.cornerLabelImg && props.styles.cornerLabel} className='corner-label' style={{
            backgroundColor: props.styles.cornerLabelBgColor,
            color: props.styles.cornerLabelColor
        }}>
                    {props.styles.cornerLabel}
                  </View>
                  <View className='line' style={{
            backgroundColor: props.styles.listBackground
        }}>
                    <View className='line-item flex'>
                      <Text className='site'>{item.departCityName}</Text>
                      <Image x-if={!(tripType === 1)} className='arrow refund' source={{
            uri: 'https://p1.meituan.net/travelcube/e620d0f1aaa2879f10e36c8050a0757c409.png'
        }}/>
                      <Image x-else className='arrow' source={{
            uri: 'https://p0.meituan.net/travelcube/00a949c7e646956cb48a18f9edbd50a1267.png'
        }}/>
                      <Text className='site back'>{item.arriveCityName}</Text>
                    </View>
                    <View className='date'>
                      <Text x-if={!(tripType === 1)} className='date-go'>去 {item.date}</Text>
                      <Text x-else className='date-go'>{item.date}</Text>
                      <Text x-if={!(tripType === 1)} className='date-back'>返 {item.backDate}</Text>
                    </View>
                  </View>
                  <View className='price'>
                    <Text className='price-symbol' style={{
            color: props.styles.priceColor
        }}>￥</Text>
                    <Text className='large' style={{
            color: props.styles.priceColor
        }}>{item.price}</Text>
                    <Text x-if={!(tripType === 1)} className='price-symbol'>起</Text>
                  </View>
                </View>;
    })}
          </View>

          
          <View x-if={props.styles.ui === '3'} className='wrapper-ui-3'>
            {flightData.map((item, index) => {
        return <View className='wrapper-ui-3-list' key={index} onClick={() => jumpList(item, index)} style={{
            backgroundColor: props.styles.listBackground
        }}>
                  <Image x-if={props.styles.cornerLabelImg} className='wrapper-ui-3-corner-img' source={{
            uri: getImageUrl(props.styles.cornerLabelImg, 64, 0)
        }} resizeMode='contain'/>
                  <View className='wrapper-ui-3-corner-label-container'>
                  <Text x-if={!props.styles.cornerLabelImg && props.styles.cornerLabel} className='wrapper-ui-3-corner-label' style={{
            backgroundColor: props.styles.cornerLabelBgColor,
            color: props.styles.cornerLabelColor
        }}>
                    {props.styles.cornerLabel}
                  </Text>
                  </View>
                  <Image className='wrapper-ui-3-item-img' source={{
            uri: item.imgUrl ? getImageUrl(item.imgUrl, 240, 0) : ''
        }}/>
                  <Text className='wrapper-ui-3-city'>{item.departCityName} - {item.arriveCityName}</Text>
                  <View className='wrapper-ui-3-label'>
                    <Image className='wrapper-ui-3-label-img' source={{
            uri: getImageUrl(props.styles.labelImg, 64, 0)
        }}/>
                    <Text x-if={!props.styles.labelImg && props.styles.labelWord} className='wrapper-ui-3-label-word' style={{
            backgroundColor: props.styles.labelWordBgColor,
            color: props.styles.labelWordColor
        }}>
                      {props.styles.labelWord}
                    </Text>
                  </View>
                  <Text className='wrapper-ui-3-price' style={{
            color: props.styles.priceColor
        }}>
                    <Text className='wrapper-ui-3-price-rmb'>￥</Text>
                    <Text className='wrapper-ui-3-price-large'>{item.price}</Text>
                    <Text x-if={!(tripType === 1)} className='wrapper-ui-3-price-rmb'>起</Text>
                    <Text className='wrapper-ui-3-price-xie-line'>/</Text>人
                  </Text>
                  <Text className='wrapper-ui-3-button' style={{
            backgroundColor: props.styles.buttonBackground
        }}>立即抢购</Text>
                </View>;
    })}
          </View>
        </View>
      </View>

    </View>;
};
export default memo(FlightRound);
